import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {SearchAssociationsAction, userDetailAction} from '../action';

function* execute({payload}: SearchAssociationsAction): SagaIterator {
    const response = yield* call(Api.searchAssociations, {text: payload});

    if (response.isSuccess) {
        yield* put(userDetailAction.setAssociationOptions(response.data));
    } else {
        yield putAll(showBeError(response, t('userDetail')('associationsLoading')));
    }
}

export function* searchAssociationsSaga(): SagaIterator {
    yield takeLatestF('userDetail/SEARCH_ASSOCIATIONS', execute);
}
